export default "__VITE_ASSET__C$4Ya92y__"